import { create } from "zustand";

/**
 * 1. Visit webapp page and complete sign-in flow
 * 2. Get a session endpoint by calling SessionService - CreateBrowser API or from cached session endpoint
 * 3. Display webapp loading definite/indefinite progress spinner
 * 4. AS2 session started - not in-session script/Chrome browser. It will show toolbar and in-session wallpaper loading image
 * 5. Launch Chrome browser. WSB portal is fully ready to use.
 *
 * All the timestamp are logging the first time event timestamp.
 */
interface UseSessionLaunchMetricStoreStore {
    sessionEndpointCreatedTimestamp: number | null;
    cachedSessionEndpointLoadedTimestamp: number | null;
    as2SessionReadyTimestamp: number | null;
    // This will also reset cachedSessionEndpointLoadedTimestamp value
    setSessionEndpointCreatedTimestamp: (timestamp?: number) => void;
    // This will also reset sessionEndpointCreatedTimestamp value
    setCachedSessionEndpointLoadedTimestamp: (timestamp?: number) => void;
    setAs2SessionReadyTimestamp: (timestamp?: number) => void;
    // Reset as2SessionReadyTimestamp value to null
    clearAs2SessionReadyTimestamp: () => void;
}

export const useSessionLaunchMetricStore =
    create<UseSessionLaunchMetricStoreStore>((set) => ({
        sessionEndpointCreatedTimestamp: null,
        cachedSessionEndpointLoadedTimestamp: null,
        as2SessionReadyTimestamp: null,
        setSessionEndpointCreatedTimestamp: (timestamp) => {
            set((state) => ({
                ...state,
                cachedSessionEndpointLoadedTimestamp: null,
                sessionEndpointCreatedTimestamp: timestamp ?? Date.now(),
            }));
        },
        setCachedSessionEndpointLoadedTimestamp: (timestamp) => {
            set((state) => ({
                ...state,
                sessionEndpointCreatedTimestamp: null,
                cachedSessionEndpointLoadedTimestamp: timestamp ?? Date.now(),
            }));
        },
        setAs2SessionReadyTimestamp: (timestamp) => {
            set((state) => ({
                ...state,
                as2SessionReadyTimestamp: timestamp ?? Date.now(),
            }));
        },
        clearAs2SessionReadyTimestamp: () => {
            set((state) => ({
                ...state,
                as2SessionReadyTimestamp: null,
            }));
        },
    }));
